import { render, staticRenderFns } from "./create.vue?vue&type=template&id=6f9cd0a0"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9cd0a0')) {
      api.createRecord('6f9cd0a0', component.options)
    } else {
      api.reload('6f9cd0a0', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=6f9cd0a0", function () {
      api.rerender('6f9cd0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/resource/create.vue"
export default component.exports